import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "@/common/axiosInstance";

// ---------- update-cart ----------

// ---------- get-cart response types ----------

// ---------- API functions ----------

export var updateCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(cartId, items) {
    var _ref2, _res$data, res, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetcher().post("/cart/update-cart", {
            cart_id: cartId,
            items: items
          });
        case 1:
          res = _context.v;
          return _context.a(2, (_ref2 = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) !== null && _ref2 !== void 0 ? _ref2 : null);
        case 2:
          _context.p = 2;
          _t = _context.v;
          return _context.a(2, null);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function updateCart(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getCart = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(cartId) {
    var _ref4, _res$data2, params, res, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _context2.p = 0;
          params = cartId ? {
            cart_id: cartId
          } : {};
          _context2.n = 1;
          return fetcher().get("/cart/get-cart", {
            params: params
          });
        case 1:
          res = _context2.v;
          return _context2.a(2, (_ref4 = res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data) !== null && _ref4 !== void 0 ? _ref4 : null);
        case 2:
          _context2.p = 2;
          _t2 = _context2.v;
          return _context2.a(2, null);
      }
    }, _callee2, null, [[0, 2]]);
  }));
  return function getCart(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var checkoutCart = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(cartId, successUrl, failureUrl) {
    var _res$data3, _data$paymentSession$, _data$paymentSession, res, data, _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          _context3.p = 0;
          _context3.n = 1;
          return fetcher().post("/cart/checkout", {
            cart_id: cartId,
            success_url: successUrl,
            failure_url: failureUrl
          });
        case 1:
          res = _context3.v;
          data = res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data;
          return _context3.a(2, (_data$paymentSession$ = data === null || data === void 0 ? void 0 : (_data$paymentSession = data.paymentSession) === null || _data$paymentSession === void 0 ? void 0 : _data$paymentSession.paymentSession) !== null && _data$paymentSession$ !== void 0 ? _data$paymentSession$ : null);
        case 2:
          _context3.p = 2;
          _t3 = _context3.v;
          return _context3.a(2, null);
      }
    }, _callee3, null, [[0, 2]]);
  }));
  return function checkoutCart(_x4, _x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();